import { FC, DragEvent, ChangeEvent, useRef, useEffect } from 'react'
import { Input, InputProps } from '@chakra-ui/react'

import getFormatedFile from 'utils/transforms/string/formatFile'
import DropzoneContent from './components/DropzoneContent'
import DropzoneWrapper from './components/DropzoneWrapper'
import { DropzoneProps } from './types'
import { UploadFile } from 'types'

type Props = DropzoneProps & {
  inputProps?: InputProps
}

const Dropzone: FC<Props> = ({ isMultiple = false, isDisabled = false, validation = {}, inputProps, onUpload }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleInputClick = (): void => {
    if (inputRef.current) inputRef.current.value = ''
    inputRef.current?.click()
  }

  const handleOnUpload = async (files: FileList): Promise<void> => {
    if (isMultiple) {
      const formatedFiles: UploadFile[] = []
      for (const fileItem of files) {
        const file = getFormatedFile(fileItem)
        formatedFiles.push(file)
      }
      await onUpload(formatedFiles)
    } else {
      for (const fileItem of files) {
        const file = getFormatedFile(fileItem)
        await onUpload(file)
      }
    }
  }

  const handleOnDrop = async (event: DragEvent<HTMLDivElement>): Promise<void> => {
    event.preventDefault()
    const files = event.dataTransfer.files
    if (event.dataTransfer && files.length != 0) {
      await handleOnUpload(files)
    }
  }

  const handleOnChange = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
    event.preventDefault()
    const files = event.target.files
    if (files && files.length != 0) {
      await handleOnUpload(files)
    }
  }

  useEffect(() => {}, [])

  return (
    <>
      <DropzoneWrapper isDisabled={isDisabled} dispatchInputClick={handleInputClick} onDrop={handleOnDrop}>
        <DropzoneContent
          extensions={validation?.extensions || []}
          minSize={validation?.min}
          maxSize={validation?.max}
        />
      </DropzoneWrapper>

      <Input
        ref={inputRef}
        multiple={isMultiple}
        isDisabled={isDisabled}
        hidden
        type="file"
        onChange={handleOnChange}
        {...inputProps}
      />
    </>
  )
}

export default Dropzone
